import { gql } from '@apollo/client';
const UPDATE_CURRENT_TENANT_DEFAULT_CURRENCY = gql `
  mutation UpdateCurrentTenantDefaultCurrency($currencyId: ID) {
    updateCurrentTenantDefaultCurrency(currencyId: $currencyId) {
      tenant {
        id
        defaultCurrency {
          id
          isoCode
          name
        }
      }
    }
  }
`;
export default UPDATE_CURRENT_TENANT_DEFAULT_CURRENCY;
